import {createAction} from 'redux-actions';
import * as ACTION from '../constants';

export const fetchDetailWarehouse = createAction(ACTION.FETCH_DETAIL_WAREHOUSE.REQUEST, (id) => ({id}));
export const clearState = createAction(ACTION.CLEAR_STATE);
